import React, { useState } from 'react';
import _ from 'lodash';
import ReactDragListView from 'react-drag-listview';

import styles from './CategoryList.module.css';
import SubcategoryItem from './SubcategoryItem';

const CategoryItem = ({
  id,
  name,
  productsCount,
  subcategories,
  isUpdating,
  updateCategories,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const subcategoriesSize = _.size(subcategories);
  const hasChildren = subcategoriesSize > 0;
  const rightContent = hasChildren
    ? `${subcategoriesSize} ${
        subcategoriesSize > 1 ? 'Subcategories' : 'Subcategory'
      }`
    : `${productsCount} ${productsCount > 1 ? 'Products' : 'Product'}`;
  const icon = isExpanded ? 'far fa-chevron-down' : 'far fa-chevron-right';
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...subcategories];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      updateCategories(data, id);
    },
    nodeSelector: '.subcategories>li',
    handleSelector: !isUpdating && '.subcategories .reorder-button',
    lineClassName: 'react-drag-line',
  };

  const handleClickExpand = () => {
    setIsExpanded((prevState) => !prevState);
  };

  return (
    <li className={styles.category}>
      <div>
        <div
          className={`${styles.container} ${isExpanded ? styles.expanded : ''}`}
        >
          <div>
            <button
              type="button"
              className={`naked-button ${styles.button}`}
              disabled={!hasChildren}
              onClick={handleClickExpand}
            >
              <i className={icon} />
            </button>
            <span className={styles.name}>{name}</span>
          </div>
          <span className={styles.rightContent}>{rightContent}</span>
        </div>
        {isExpanded && (
          <ReactDragListView {...dragProps}>
            <ul className="subcategories">
              {_.map(subcategories, (subcategory) => {
                const {
                  id: scId,
                  name: scName,
                  productsCount: scProductsCount,
                } = subcategory;
                return (
                  <SubcategoryItem
                    key={scId}
                    name={scName}
                    productsCount={scProductsCount}
                  />
                );
              })}
            </ul>
          </ReactDragListView>
        )}
      </div>
      <button
        type="button"
        className={`naked-button reorder-button ${styles.reorderButton}`}
        style={{ marginLeft: 12 }}
      >
        <i className="far fa-ellipsis-v" />
        <i className="far fa-ellipsis-v" />
      </button>
    </li>
  );
};

export default CategoryItem;
